import { TODO } from '@b2c/types/index';
import angular, { IFilterService, IHttpService } from 'angular';
import { EventsServiceModule } from '../events/events.service';
import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import { QueryStringBuilderFactoryModule } from '@b2c/common/factories/QueryStringBuilder/QueryStringBuilder.factory';

export interface OrderData {
  id: string;
  tenantId: 107;
  visitorId: string;
  email: string;
  billingEmail: string;
  contactFirstName: string;
  contactLastName: string;
  billingFirstName: string;
  billingLastName: string;
  billingAddress1: string;
  billingCountry: string;
  billingCity: string;
  billingZipCode: string;
  billingState: string;
  address1: string;
  country: string;
  city: string;
  state: string;
  zipCode: string;
  phoneNumber: string;
  billingPhoneNumber: string;
  orderNumber: string;
  discountedTotalAmount: string;
  totalAmount: string;
  discountedOriginalTotalAmount: string;
  originalTotalAmount: string;
  paidAmount: string;
  balanceAmount: string;
  refundAmount: string;
  saleChannel: string;
  checkInStatus: string;
  notes: string;
  creationDate: string;
  paymentDueDate: string;
  orderItems: OrderItem[];
  createdOn: string;
  createdBy: string;
  updatedOn: string;
  updatedBy: string;
  ticketDelivery: string;
  legacy: boolean;
  hideEventDate: boolean;
  membershipId: number;
  ccLastFourDigits: string;
  invoiceAfter: false;
  customerId: boolean;
  obfuscated: boolean;
}

export interface OrderItem {
  itemId2: string;
  itemName: string;
  pricePointId: string;
  pricePointName: string;
  itemDetailId: string;
  parentItemId: string;
  comboTemplateType: string;
  basicOriginalQuantity: number;
  originalQuantity: number;
  basicQuantity: number;
  quantity: number;
  unitPrice: string;
  discountedUnitPrice: string;
  discountedOriginalAmount: string;
  originalAmount: string;
  discountedAmount: string;
  amount: string;
  balanceAmount: string;
  itemType: string;
  itemTypeNg: string;
  conversionStatus: string;
  itemId: string;
}

export const OrdersServiceModule = angular
  .module('acme.common.service.order', [
    EventsServiceModule, 
    ApiVersionFactoryModule, 
    QueryStringBuilderFactoryModule
  ])
  .service('OrderService', [
    '$http',
    '$filter',
    'EventsService',
    'ApiVersionFactory',
    'QueryStringBuilderFactory',
    function (
      $http: IHttpService, 
      $filter: IFilterService, 
      EventsService: TODO, 
      ApiVersionFactory: TODO, 
      QueryStringBuilderFactory: TODO
    ) {
      return {
        // Orders is used for placed orders on the Backend
        // Orders is used as a temporary holding area during the order process on the Front-End
        // Orders API connects to the appropriate orders backend and is not related to the Orders Front-End in functionality
        api: {
          av_orders: new ApiVersionFactory({
            url: '/v1/b2c/orders',
            version: 'v2',
          }),

          list: function (tenantId, props) {
            var q = '',
              qs;

            if (props) {
              qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['pageSize', 'page', 'sortField', 'sortDirection'],
                },
              });
              q = qs.query;
            }
            return $http({
              method: 'get',
              url: this.av_orders.url + '/search' + q,
              headers: {
                'x-b2c-tenant-id': tenantId,
              },
            });
          },

          detail: function (props: { tenantId: number, orderId: number }) {
            return $http({
              method: 'get',
              url: this.av_orders.url + '/' + props.orderId,
              headers: {
                'x-b2c-tenant-id': props.tenantId,
              },
            });
          },
        },

        date: '',
        orders: [],
        upsells: [],
        prerequisites: [],
        GAEvent: {},
        donationErrors: {},

        init: function () {},

        setDate: function (date) {
          this.date = date;
        },

        getDate: function () {
          return this.date;
        },

        getTicketMultiplier: function (price) {
          var i,
            ii,
            r = 0;

          if (
            price &&
            price.personType &&
            price.personType.type.toLowerCase() === 'combo' &&
            price.personType.children instanceof Array
          ) {
            for (i = 0, ii = price.personType.children.length; i < ii; i++) {
              r += +price.personType.children[i].quantity;
            }
          } else {
            r = 1;
          }

          // Never return a zero multiplier
          return r;
        },

        getTotalTickets: function () {
          var i,
            ii,
            j,
            jj,
            k,
            kk,
            l,
            ll,
            entry,
            orders = this.orders.concat(this.GAEvent),
            total = 0;

          for (i = 0, ii = orders.length; i < ii; i++) {
            if (
              orders[i].hasOwnProperty('priceLists') &&
              orders[i].priceLists instanceof Array &&
              orders[i].priceLists[0]
            ) {
              for (j = 0, jj = orders[i].priceLists[0].prices.length; j < jj; j++) {
                if (orders[i].priceLists[0].prices[j].hasOwnProperty('quantity')) {
                  total +=
                    +orders[i].priceLists[0].prices[j].quantity *
                    this.getTicketMultiplier(orders[i].priceLists[0].prices[j]);
                }
                if (orders[i].priceLists[0].prices[j].hasOwnProperty('retailQuantity')) {
                  total +=
                    +orders[i].priceLists[0].prices[j].retailQuantity *
                    this.getTicketMultiplier(orders[i].priceLists[0].prices[j]);
                }
              }
            } else if (orders[i].type === 'fixedPrice') {
              for (j = 0, jj = orders[i].priceList.prices.length; j < jj; j++) {
                if (orders[i].priceList.prices[j].hasOwnProperty('quantity')) {
                  total +=
                    +orders[i].priceList.prices[j].quantity * this.getTicketMultiplier(orders[i].priceList.prices[j]);
                }
              }
            } else if (orders[i].type === 'discountCode') {
              // Perform validation here for discount
              for (j = 0, jj = orders[i].templates.entries.length; j < jj; j++) {
                entry = orders[i].templates.entries[j];
                if (entry.template) {
                  for (k = 0, kk = entry.template.priceLists[0].prices.length; k < kk; k++) {
                    if (entry.template.priceLists[0].prices[k].quantity) {
                      total +=
                        +entry.template.priceLists[0].prices[k].quantity *
                        this.getTicketMultiplier(entry.template.priceLists[0].prices[k]);
                    }
                  }
                } else if (entry.summaries) {
                  for (k = 0, kk = entry.summaries.length; k < kk; k++) {
                    for (l = 0, ll = entry.summaries[k].priceLists[0].prices.length; l < ll; l++) {
                      if (entry.summaries[k].priceLists[0].prices[l].quantity) {
                        total +=
                          +entry.summaries[k].priceLists[0].prices[l].quantity *
                          this.getTicketMultiplier(entry.summaries[k].priceLists[0].prices[l]);
                      }
                    }
                  }
                }
              }
            }
          }

          return total;
        },

        getTotalAddOns: function () {
          var i,
            ii,
            j,
            jj,
            orders = this.orders.concat(this.GAEvent),
            total = 0;

          for (i = 0, ii = orders.length; i < ii; i++) {
            if (orders[i].hasOwnProperty('addOns') && orders[i].addOns.inventoryAddOns instanceof Array) {
              for (j = 0, jj = orders[i].addOns.inventoryAddOns.length; j < jj; j++) {
                if (orders[i].addOns.inventoryAddOns[j].hasOwnProperty('totalQuantity')) {
                  total += +orders[i].addOns.inventoryAddOns[j].totalQuantity;
                }
              }
            }
          }

          return total;
        },

        getTotalDonations: function () {
          var i,
            ii,
            j,
            jj,
            orders = this.orders,
            total = 0;

          for (i = 0, ii = orders.length; i < ii; i++) {
            if (
              orders[i].hasOwnProperty('type') &&
              (orders[i].type === 'fixedDonation' || orders[i].type === 'donation')
            ) {
              total += Number(orders[i].price);
            }
          }

          return total;
        },

        getTotalMemberships: function () {
          var i,
            ii,
            j,
            jj,
            orders = this.orders.concat(this.GAEvent),
            total = 0;

          for (i = 0, ii = orders.length; i < ii; i++) {
            if (orders[i].hasOwnProperty('offerings') && orders[i].offerings instanceof Array) {
              for (j = 0, jj = orders[i].offerings.length; j < jj; j++) {
                if (orders[i].offerings[j].hasOwnProperty('priceLists')) {
                  total += 1;
                }
              }
            }
          }

          return total;
        },

        /**
         * Returns sorted orders with optional donations
         * Adding the flag in order to prevent directives
         * from being redrawn due to track by $index from the result of this method
         *
         * @param prop
         * @param ignoreDonations ENG-2638
         * @returns {*}
         */
        getOrdersSortedBy: function (prop, ignoreDonations) {
          var sorted;

          if (this.orders[0] && this.orders[0].hasOwnProperty(prop)) {
            this.orders.sort(function (a, b) {
              var r = 0;
              if (a[prop] > b[prop]) {
                r = 1;
              } else if (a[prop] < b[prop]) {
                r = -1;
              }
              return r;
            });
          }

          if (ignoreDonations) {
            sorted = $filter('filter')(this.orders, function (value: TODO, index, array) {
              if (!value.type || value.type.toLowerCase().indexOf('donation') === -1) {
                return true;
              }
            });
          } else {
            sorted = this.orders;
          }

          return sorted;
        },

        hasDonationsErrors: function () {
          var r = false,
            key;
          if (this.donationErrors) {
            for (key in this.donationErrors) {
              if (this.donationErrors.hasOwnProperty(key)) {
                r = true;
                break;
              }
            }
          }
          return r;
        },

        restoreFromCart: function (cart) {
          return {
            events: this.restoreEventsFromCart(cart),
            combos: this.restoreCombosFromCart(cart),
            memberships: this.restoreMembershipsFromCart(cart),
            donations: this.restoreDonationsFromCart(cart),
          };
        },

        restoreEventsFromCart: function (cart) {
          var i, ii;
          var eventIndex;
          var missing: TODO[] = []; // Store missing templates

          if (cart.templates instanceof Array) {
            for (i = 0, ii = cart.templates.length; i < ii; i++) {
              if ((eventIndex = this.findEventItemById('upsells', cart.templates[i].eventTemplateId)) !== false) {
                this.orders.concat.apply(this.upsells.splice(eventIndex, 1));
              } else if ((eventIndex = this.findEventItemById('orders', cart.templates[i].eventTemplateId)) !== false) {
                // Do nothing
              } else {
                missing.push(cart.templates[i].eventTemplateId);
              }
            }
          }

          return missing;
        },

        restoreDonationsFromCart: function (cart) {
          var donationIndex;
          var missing: TODO[] = []; // Store missing templates

          if (cart.donations instanceof Array) {
            for (let i = 0, ii = cart.donations.length; i < ii; i++) {
              if ((donationIndex = this.findDonationItemById('orders', cart.donations[i].inventoryId)) === false) {
                missing.push(cart.donations[i].inventoryId);
              }
            }
          }

          return missing;
        },

        restoreMembershipsFromCart: function (cart) {
          var i, ii;
          var membershipIndex: TODO;
          var missing: TODO[] = []; // Store missing memberships

          if (cart.memberships instanceof Array) {
            for (i = 0, ii = cart.memberships.length; i < ii; i++) {
              if (
                cart.memberships[i].membershipInfo.isGift ||
                (membershipIndex = this.findMembershipItemById(
                  'orders',
                  cart.memberships[i].membershipInfo.membershipCategoryId
                )) === false
              ) {
                missing.push({
                  id: cart.memberships[i].id,
                  membershipCategoryId: cart.memberships[i].membershipInfo.membershipCategoryId,
                });
              }
            }
          }

          return missing;
        },

        restoreCombosFromCart: function (cart) {
          var eventIndex;
          var missing: TODO[] = []; // Store missing templates

          if (cart.comboItems instanceof Array) {
            for (let i = 0, ii = cart.comboItems.length; i < ii; i++) {
              if ((eventIndex = this.findEventItemById('upsells', cart.comboItems[i].comboTemplateId)) !== false) {
                this.orders.concat.apply(this.upsells.splice(eventIndex, 1));
              } else if (
                (eventIndex = this.findEventItemById('orders', cart.comboItems[i].comboTemplateId)) !== false
              ) {
                // Do nothing
              } else {
                missing.push(cart.comboItems[i].comboTemplateId);
              }
            }
          }

          return missing;
        },

        updateEventsFromCart: function (cart) {
          var i, ii;
          var eventIndex;
          var updated: TODO[] = []; // Store updated templates

          for (i = 0, ii = cart.templates.length; i < ii; i++) {
            if ((eventIndex = this.findEventItemById('upsells', cart.templates[i].eventTemplateId)) !== false) {
              this.orders.concat.apply(this.upsells.splice(eventIndex, 1));
            } else if ((eventIndex = this.findEventItemById('orders', cart.templates[i].eventTemplateId)) !== false) {
              // Do nothing
              updated.push(cart.templates[i].eventTemplateId);
            } else {
              //do nothing
            }
          }

          return updated;
        },

        findEventItemById: function (bucket, id) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this[bucket].length; i < ii; i++) {
            if (this[bucket][i].id === id) {
              r = i;
              break;
            }
          }

          return r;
        },

        findDonationItemById: function (bucket, id) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this[bucket].length; i < ii; i++) {
            if (this[bucket][i].id === id) {
              r = i;
              break;
            }
          }

          return r;
        },

        findMembershipItemById: function (bucket, id) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this[bucket].length; i < ii; i++) {
            if (this[bucket][i].id === id) {
              r = i;
              break;
            }
          }

          return r;
        },

        findMembershipItemByOrderItem: function (bucket, orderItem) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this[bucket].length; i < ii; i++) {
            if (this[bucket][i].id === orderItem.id && this[bucket][i].action === orderItem.action) {
              r = i;
              break;
            }
          }

          return r;
        },

        donationItemInOrders: function (donationItem) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this.orders.length; i < ii; i++) {
            if (this.orders[i].inventoryId === donationItem.inventoryId) {
              r = true;
            }
          }

          return r;
        },

        addonItemInOrders: function (addonItem) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this.orders.length; i < ii; i++) {
            if (this.orders[i].inventoryId === addonItem.inventoryId) {
              r = true;
            }
          }

          return r;
        },

        addonItemInUpsells: function (addonItem) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this.upsells.length; i < ii; i++) {
            if (this.upsells[i].inventoryId === addonItem.inventoryId) {
              r = true;
            }
          }

          return r;
        },

        eventItemInUpsells: function (eventItem) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this.upsells.length; i < ii; i++) {
            if (this.upsells[i].id === eventItem.id) {
              r = true;
            }
          }

          return r;
        },

        eventItemInOrders: function (eventItem) {
          var i,
            ii,
            r = false;

          for (i = 0, ii = this.orders.length; i < ii; i++) {
            if (this.orders[i].id === eventItem.id) {
              r = true;
            }
          }

          return r;
        },

        membershipItemInOrders: function (membershipItem, restrictBase, swap) {
          var i, ii;
          var result = false;
          var type;
          var nonGiftOrders: TODO[] = [];
          var order;
          var membershipItemHash =
            (membershipItem.id || '') +
            (membershipItem.membershipInfo.isGift && 1) +
            (membershipItem.membershipInfo.auxiliary && 1);

          if (membershipItem.isGift || membershipItem.action === 'gift') {
            //if it's not a gift, only check the id, not the itemId (shoppingCart
            membershipItemHash = membershipItemHash + (membershipItem.itemId || '');
          }

          order = this.getMembershipItemFromOrders(membershipItemHash, membershipItem.isGift);

          if (!order && restrictBase) {
            nonGiftOrders = this.getNonGiftMembershipOrders(membershipItem.membershipInfo.auxiliary);

            if (!membershipItem.auxiliary) {
              //we need to check that there is only 1 non-gift base (new or lifecycle)

              for (i = 0, ii = nonGiftOrders.length; i < ii; i++) {
                type = nonGiftOrders[i].itemType;

                if (
                  type === membershipItem.itemType ||
                  (nonGiftOrders[i].membershipInfo.membershipId &&
                    nonGiftOrders[i].membershipInfo.membershipId === membershipItem.membershipInfo.membershipId)
                ) {
                  result = true;
                  if (swap) {
                    membershipItemHash =
                      (nonGiftOrders[i].id || '') +
                      (nonGiftOrders[i].membershipInfo.isGift && 1) +
                      (nonGiftOrders[i].membershipInfo.auxiliary && 1);
                    if (nonGiftOrders[i].membershipInfo.isGift) {
                      //if it's not a gift, only check the id, not the itemId (shoppingCart
                      membershipItemHash = membershipItemHash + (nonGiftOrders[i].itemId || '');
                    }
                    order = this.getMembershipItemFromOrders(
                      membershipItemHash,
                      nonGiftOrders[i].membershipInfo.isGift
                    );
                    this.orders[order.index] = membershipItem;
                  }
                }
              }
            }
          } else {
            result = true;
          }

          return result;
        },

        getNonGiftMembershipOrders: function (auxiliary) {
          var r = [];
          if (this.orders instanceof Array) {
            r = this.orders.filter(function (order) {
              var test = order.membershipInfo && !order.membershipInfo.isGift;
              if (auxiliary) {
                test = test && order.membershipInfo.auxiliary;
              } else {
                test = test && !order.membershipInfo.auxiliary;
              }
              return test;
            });
          }
          return r;
        },

        getMembershipOrders: function (list) {
          var result: TODO[] = [];
          var orders = list || this.orders;

          if (orders instanceof Array) {
            result = orders.filter(function (order) {
              return order.membershipInfo;
            });
          }
          return result;
        },

        getMembershipItemFromOrders: function (itemHash, includeItemId) {
          var i, ii;
          var orderItemHash;
          var result: TODO | false = false;

          for (i = 0, ii = this.orders.length; i < ii; i++) {
            orderItemHash =
              (this.orders[i].id || '') +
              (this.orders[i].membershipInfo.isGift && 1) +
              (this.orders[i].membershipInfo.auxiliary && 1);

            if (includeItemId) {
              orderItemHash = orderItemHash + (this.orders[i].itemId || '');
            }
            if (orderItemHash === itemHash) {
              result = {
                index: i,
                item: this.orders[i],
              };
            }
          }

          return result;
        },

        getDonationItemFromOrders: function () {
          var result: TODO | false = false;

          for (let i = 0, ii = this.orders.length; i < ii; i++) {
            if (
              (this.orders[i].itemType === 'Inventory' || this.orders[i].itemType === 'Donation') &&
              this.orders[i].hasOwnProperty('type') &&
              (this.orders[i].type === 'fixedDonation' || this.orders[i].type === 'donation')
            ) {
              result = {
                index: i,
                item: this.orders[i],
              };
            }
          }

          return result;
        },

        eventItemPrerequisitesMet: function (eventItem) {
          var i, ii;
          var j, jj;
          var r = false;
          var pre: TODO[] = [];
          var required: TODO[] = [];

          if (EventsService.hasPrerequisites(eventItem)) {
            pre = eventItem.prerequisites.requires;

            // May or may not GA requirement so we need to set r to false in case we don't find anything
            outer: for (i = 0, ii = pre.length; i < ii; i++) {
              required = this.orders.slice(0);
              // Meets GA requirement
              if (this.GAEvent.hasOwnProperty('id') && pre[i].eventTemplateId === this.GAEvent.id) {
                required.push(this.GAEvent);
              }
              for (j = 0, jj = required.length; j < jj; j++) {
                if (pre[i].eventTemplateId === required[j].id) {
                  r = true;
                  break outer;
                } else {
                  r = false;
                }
              }
            }
          } else {
            // If there are no prerequisites they are already met
            r = true;
          }

          return r;
        },

        upsellsExist: function () {
          return this.upsells instanceof Array && this.upsells.length > 0;
        },
      };
    },
  ]).name;
